import { CodeComplexValue } from 'app/area/shared/codetable/types';
import { Filter, PredefinedFilter } from 'app/area/search-filters/filters/types';

export interface ShouldHideFiltersDrawerPayload {
  queryFilters: CodeComplexValue<string>[];
  predefinedFilters: PredefinedFilter;
  customFilters: Filter[];
}

export const codeSearchArea = 'code';
